import { MatDateFormats } from '@angular/material/core';

export const DDMMYY_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { day: '2-digit', month: '2-digit', year: '2-digit' }
  },
  display: {
    dateInput: { day: '2-digit', month: '2-digit', year: '2-digit' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};
